import React, { PropsWithChildren, useState } from 'react';

export type TPersonalizationCustomizationContext = {
    activePersonalizations: {[name: string]: boolean}
    setActivePersonalizations: React.Dispatch<React.SetStateAction<{[name: string]: boolean}>>,
};

const PersonalizationCustomizationContext = React.createContext<TPersonalizationCustomizationContext>({
    activePersonalizations: {},
    setActivePersonalizations: () => {},
});

export const usePersonalizationCustomizationContext = () => React.useContext(PersonalizationCustomizationContext);

const PersonalizationCustomizationContextProvider = ( { children }: PropsWithChildren<any> ): JSX.Element => {
    const [activePersonalizations, setActivePersonalizations] = useState<{[name: string]: boolean}>({});

    return (<PersonalizationCustomizationContext.Provider 
        value={{
            activePersonalizations,
            setActivePersonalizations,
        }}
    >
        {children}
    </PersonalizationCustomizationContext.Provider>);
};

export default PersonalizationCustomizationContextProvider;